import React, { Component, Fragment } from 'react';
import { Row, Col, FormGroup, Input, Label, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';
import Validation from '../../../services/Validation';

class VehicleCount extends Component {

  isMobile = false;

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      controls: props.controls || {},
      isValidForm: !!this.props.isEdit
    };
  }

  componentDidMount() {
    this.handleValidation();
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].touched = true;
    if (controlValue < 0) {
      return;
    }
    controls[controlName].value = +controlValue;
    this.setState({ controls });

    if (this.props.isEdit) {
      const obj = {
        '4_wheeler': +controls.fourWheeler.value || 0,
        '6_wheeler': +controls.sixWheeler.value || 0,
        // '8_wheeler': +controls.eightWheeler.value || 0,
        '10_wheeler': +controls.tenWheeler.value || 0,
        '12_wheeler': +controls.twelveWheeler.value || 0,
        '14_wheeler': +controls.fourteenWheeler.value || 0,
        '16_wheeler': +controls.sixteenWheeler.value || 0,
        '18_wheeler': +controls.eighteenWheeler.value || 0,
        '22_wheeler': +controls.twentyTwoWheeler.value || 0,
        '28_wheeler': +controls.twentyEightWheeler.value || 0,
      };

      this.props.updateState({ visibleArea: 'vehicleCount', controls, isEdit: this.props.isEdit, editIndex: this.props.editIndex, updatedCount: obj });
    } else {
      this.props.updateState({ visibleArea: 'vehicleCount', controls, isEdit: false, editIndex: -1 });
    }

    this.handleValidation();
  }

  handleValidation = () => {
    const { controls } = this.state;
    let { isValidForm } = this.state;
    let { fourWheeler, sixWheeler, tenWheeler, twelveWheeler, fourteenWheeler, sixteenWheeler, eighteenWheeler, twentyTwoWheeler, twentyEightWheeler } = controls;

    if (controls.vehicleType.value && (controls.vehicleType.value.name || '').toLowerCase() === 'truck') {

      if (sixWheeler.touched === true) {
        sixWheeler = Validation.notNullValidator(sixWheeler);
        sixWheeler.valid = !sixWheeler.nullValue;
      }

      if (tenWheeler.touched === true) {
        tenWheeler = Validation.notNullValidator(tenWheeler);
        tenWheeler.valid = !tenWheeler.nullValue;

      }

      if (twelveWheeler.touched === true) {
        twelveWheeler = Validation.notNullValidator(twelveWheeler);
        twelveWheeler.valid = !twelveWheeler.nullValue;

      }

      if (fourteenWheeler.touched === true) {
        fourteenWheeler = Validation.notNullValidator(fourteenWheeler);
        fourteenWheeler.valid = !fourteenWheeler.nullValue;

      }

      if (sixteenWheeler.touched === true) {
        sixteenWheeler = Validation.notNullValidator(sixteenWheeler);
        sixteenWheeler.valid = !sixteenWheeler.nullValue;

      }

      if (eighteenWheeler.touched === true) {
        eighteenWheeler = Validation.notNullValidator(eighteenWheeler);
        eighteenWheeler.valid = !eighteenWheeler.nullValue;

      }

      if (twentyTwoWheeler.touched === true) {
        twentyTwoWheeler = Validation.notNullValidator(twentyTwoWheeler);
        twentyTwoWheeler.valid = !twentyTwoWheeler.nullValue;

      }

      if (twentyEightWheeler.touched === true) {
        twentyEightWheeler = Validation.notNullValidator(twentyEightWheeler);
        twentyEightWheeler.valid = !twentyEightWheeler.nullValue;
      }

      if (sixWheeler.valid || tenWheeler.valid || twelveWheeler.valid || fourteenWheeler.valid || sixteenWheeler.valid || eighteenWheeler.valid || twentyTwoWheeler.valid || twentyEightWheeler.valid) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }
    } else {
      if (fourWheeler.touched === true) {
        fourWheeler = Validation.notNullValidator(fourWheeler);
        fourWheeler.valid = !fourWheeler.nullValue;
      }

      if (sixWheeler.touched === true) {
        sixWheeler = Validation.notNullValidator(sixWheeler);
        sixWheeler.valid = !sixWheeler.nullValue;
      }

      // if (eightWheeler.touched === true) {
      //   eightWheeler = Validation.notNullValidator(eightWheeler);
      //   eightWheeler.valid = !eightWheeler.nullValue;
      // }

      if (fourWheeler.valid || sixWheeler.valid) {
        isValidForm = true;
      } else {
        isValidForm = false;
      }
    }
    this.setState({ controls, isValidForm });
  }


  goBack = () => {
    const { controls } = this.state;
    this.props.updateState({ visibleArea: 'vehicleMake', controls });
  }

  render() {

    const { controls, isValidForm } = this.state;
    const { fourWheeler, sixWheeler, tenWheeler, twelveWheeler, fourteenWheeler, sixteenWheeler, eighteenWheeler, twentyTwoWheeler, twentyEightWheeler } = controls;

    return (
      <>
        <Row className="fleet-customer-details-label">
          <Col xl="10" xs="10" ms="10" style={{ display: 'flex' }}>
            {
              !this.props.isEdit &&
              <FontAwesomeIcon onClick={this.goBack} icon={faAngleLeft} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
            }
            &nbsp;&nbsp;
            <span style={{ marginTop: '2px' }}>COUNT</span>
          </Col>
          <Col>
            <FontAwesomeIcon className="pull-right" onClick={this.props.onCancelClick} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
          </Col>
        </Row>
        <hr />
        <Fragment>
          <Label className="input-label">Please enter the count of trucks</Label>
          <Row className="type-count">
            <Col xl="3" md="3" sm="6" xs="6">
              <span className="input-label"><b>Type</b></span>
            </Col>
            <Col xl="3" md="3" sm="6" xs="6">
              <span className="input-label"><b>Count</b></span>
            </Col>
          </Row>
          {
            controls.vehicleType.value && (controls.vehicleType.value.name || '').toLowerCase() === 'truck' &&
            <Fragment>
              <Row style={{ marginTop: '20px' }}>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">6 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="sixWheeler"
                      id="sixWheeler"
                      value={sixWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">10 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="tenWheeler"
                      id="tenWheeler"
                      value={tenWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">12 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="twelveWheeler"
                      id="twelveWheeler"
                      value={twelveWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">14 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="fourteenWheeler"
                      id="fourteenWheeler"
                      value={fourteenWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">16 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="sixteenWheeler"
                      id="sixteenWheeler"
                      value={sixteenWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">18 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="eighteenWheeler"
                      id="eighteenWheeler"
                      value={eighteenWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">22 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="twentyTwoWheeler"
                      id="twentyTwoWheeler"
                      value={twentyTwoWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">28 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="twentyEightWheeler"
                      id="twentyEightWheeler"
                      value={twentyEightWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Fragment>
          }

          {
            controls.vehicleType.value && (controls.vehicleType.value.name || '').toLowerCase() === 'bus' &&
            <Fragment>

              <Row style={{ marginTop: '20px' }}>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">4 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="fourWheeler"
                      id="fourWheeler"
                      value={fourWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">6 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="sixWheeler"
                      id="sixWheeler"
                      value={sixWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* <Row>
                <Col xl="3" md="3" sm="6" xs="6">
                  <span className="input-label">8 Wheeler</span>
                </Col>
                <Col xl="3" md="3" sm="6" xs="6">
                  <FormGroup>
                    <Input
                      type="number"
                      name="eightWheeler"
                      id="eightWheeler"
                      value={eightWheeler.value}
                      onChange={this.handleInputChange}
                      className="font-weight-bolder"
                    />
                  </FormGroup>
                </Col>
              </Row> */}
            </Fragment>
          }

        </Fragment>
        <Row style={{ marginTop: '50px' }}>
          <Col>
            {
              this.props.isEdit ?
                <Button disabled={!isValidForm} className={classnames({ 'w-100 mt-4': this.isMobile }, 'mb-1', 'mr-1', 'btn-pill', 'btn-submit', 'font-weight-bold', 'pull-right')} color="warning" onClick={this.props.onUpdateClick}>Submit</Button>
                :
                <Button disabled={!isValidForm} className={classnames({ 'w-100 mt-4': this.isMobile }, 'mb-1', 'mr-1', 'btn-pill', 'btn-submit', 'font-weight-bold', 'pull-right')} color="warning" onClick={this.props.onSubmitClick}>Submit</Button>
            }
          </Col>
        </Row>
      </>
    );
  }
}

export default VehicleCount;